import React from 'react';
import styles from './styles.module.css';
import ModuleEmptyState from '../moduleCard/ModuleEmptyState';
import VaccinesOutlinedIcon from '@mui/icons-material/VaccinesOutlined';
import { applicationViewLabel } from './applicationFigures';
import { formatAmount } from './applicationMarks';

/**
 * Lista das marcações do atendimento (todas as vistas), só leitura: produto,
 * quantidade, tipo (ponto ou traço), vista quando difere da atual e nota.
 * Clicar chama `onSelect`, que destaca a marcação na figura e, com `enabled`,
 * abre o popup de edição. `hoverIndex`/`onHover` sincronizam o destaque.
 */
const ApplicationMarkList = ({ marks, view, selectedIndex, hoverIndex, enabled, onSelect, onHover }) => {
  if (marks.length === 0) {
    return (
      <ModuleEmptyState
        icon={<VaccinesOutlinedIcon />}
        text={enabled ? 'Nenhuma marcação. Clique ou arraste na figura.' : 'Nenhuma marcação neste atendimento.'}
      />
    );
  }

  return (
    <div className={styles.list}>
      {marks.map((mark, index) => (
        <div
          key={index}
          className={[
            styles.mark_item,
            selectedIndex === index ? styles.markSelected : '',
            hoverIndex === index && selectedIndex !== index ? styles.markHover : '',
          ].join(' ')}
          style={{ '--mark-color': mark.color }}
          onClick={() => onSelect(index)}
          onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') onSelect(index); }}
          onMouseEnter={() => onHover && onHover(index)}
          onMouseLeave={() => onHover && onHover(null)}
          role="button"
          tabIndex={0}
        >
          <div className={styles.markHead}>
            <span className={styles.number} style={{ background: mark.color }}>{index + 1}</span>
            <div className={styles.markText}>
              <span className={styles.title}>{mark.product}</span>
              {mark.view !== view && (
                <span className={styles.meta}>
                  <span className={styles.tag}>{applicationViewLabel(mark.view)}</span>
                </span>
              )}
            </div>
            <span className={styles.amount}>{formatAmount(mark.quantity, mark.unit)}</span>
          </div>
          {mark.note && <span className={styles.note}>{mark.note}</span>}
        </div>
      ))}
    </div>
  );
};

export default ApplicationMarkList;
